import { Product } from '@spa/store/modules/orderHistory/types'
import { EligibilityChecker, EligibilityCheckStrategy } from './base'

/**
 * ファーストリリースでは在庫切れ商品はボタンを押せるがカート追加に失敗してエラーメッセージが出れば良いという決めをしたが、
 * 本来はボタンを押せなくしたほうが親切
 */
export interface ContextForProductLayer {
  product: Pick<Product, 'isCatalogType' | 'isNovelty' | 'isChild' | 'isContactLens'>,
}

export class EligibilityCheckerForProductLayer extends EligibilityChecker<ContextForProductLayer> {}

/**
 * ノベルティ、子商品、カタログはユーザーが自由に選択できる商品ではないので
 * user selectableの部分はもうちょっと適切な表現にしたいが・・・
 */
export class EligibleWhenProductIsUserSelectable implements EligibilityCheckStrategy<ContextForProductLayer> {
  check(context: ContextForProductLayer): boolean {
    return !context.product.isCatalogType
      && !context.product.isNovelty
      && !context.product.isChild
  }
}

export class EligibleWhenProductIsContactLens implements EligibilityCheckStrategy<ContextForProductLayer> {
  check(context: ContextForProductLayer): boolean {
    // コンタクトレンズか不明な場合はボタンは利用できない
    // 実際にはROOT非公開時にのみisContactLensがundefinedになる想定
    return context.product.isContactLens || false
  }
}
